import React from 'react'
import PropTypes from 'prop-types'
import { Row, Panel } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import styled, { withTheme } from 'styled-components'

const Wrapper = styled.div`
  .panel-heading {
    background-color: var(--clr-bg);
    cursor: pointer;
    border: none;
    padding: 5px 15px;
  }
  .panel {
    color: var(--clr-accent);
    border: none;
    box-shadow: none;
    margin: 0px;
  }
  .panel-body {
    padding: 2px 0px 2px 10px;
    background-color: var(--clr-bg);
  }
  .panel-title > button {
    font-weight: bold;
    color: var(--clr-accent);
    opacity: 0.9;
    border: 0;
    background: 0;
    text-align: left;
    width: 100%;
    padding: 2px;
  }
  .panel-title > button:hover {
    text-decoration: underline;
  }
  .panel-title > button:before {
    font-family: 'FontAwesome';
    content: '\\f077';
    float: right;
    display: block;
    transition: transform 300ms;
    font-weight: 400;
  }
  .panel-title > button:active,
  .panel-title > button:active:focus,
  .panel-title > button:focus,
  .panel-title > button:visited,
  .tutorial-links:hover,
  .tutorial-links:focus,
  .tutorial-links:active:focus {
    color: var(--clr-accent-to-white);
  }
  .panel-title > button.collapsed:before {
    transform: rotateZ(-180deg);
  }
  .tutorial-links {
    display: list-item;
    list-style-type: none;
    line-height: 1.3;
    padding: 2px;
    margin-left: 15px;
  }
  .tutorial-category-heading {
    color: var(--clr-accent-to-text);
    font-size: var(--h4);
    font-weight: bold;
    margin-bottom: 2rem;
    padding: 0 15px;
  }
`

const propTypes = {
  tutorials: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          pk: PropTypes.number.isRequired,
          tutorialtype: PropTypes.string,
          name: PropTypes.string.isRequired,
          tutorialstatus: PropTypes.string,
          tutorialCategoryName: PropTypes.string
        })
      )
    })
  ),
  query: PropTypes.object
}

const InfoBar = props => {
  const { tutorials, currentTutorialId, query } = props

  if (tutorials && tutorials.length === 0) {
    return null
  }

  const renderCategories = categories => {
    if (!categories || !currentTutorialId) {
      return null
    }

    const categoryIndex = categories.findIndex(cat => {
      return cat.children.find(
        child => parseInt(child.pk, 10) === parseInt(currentTutorialId, 10)
      )
    })

    return (
      categories.map((category, index) => (
        <Panel
          key={`tutorial_categories_${index}`}
          defaultExpanded={index === categoryIndex}
        >
          <Panel.Heading>
            <Panel.Title>
              <Panel.Toggle
                tabIndex="0"
                componentClass="button"
                aria-label={category.name}
              >
                {category.name}
              </Panel.Toggle>
            </Panel.Title>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body>
              {renderTutorials(category.children)}
            </Panel.Body>
          </Panel.Collapse>
        </Panel>
      ))
    )
  }

  const renderTutorials = (tutorials) => {
    return (
      tutorials.map((tutorial, index) => (
        <LinkContainer
          key={`tutorial_item_${index}`}
          to={{
            pathname: `/tutorials/${tutorial.categorySlug}/${tutorial.slug}`,
            query: query
          }}
        >
          <a aria-label={tutorial.name} className="tutorial-links">{tutorial.name}</a>
        </LinkContainer>
      ))
    )
  }

  return (
    <Row>
      <Wrapper id="tutorial-header">
        <div style={{ padding: '0px' }}>
          <h3 className="tutorial-category-heading">All tutorials</h3>
          {renderCategories(tutorials)}
        </div>
      </Wrapper>
    </Row>
  )
}

InfoBar.propTypes = propTypes

export default withTheme(InfoBar)



// WEBPACK FOOTER //
// ./src/components/InfoBar/InfoBar.js